// extracted by mini-css-extract-plugin
export default {"root":"TimeInput24_root__5AsW6","select":"TimeInput24_select__CI3X2","separator":"TimeInput24_separator__lNqyG"};